import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { Button } from "@/components/ui/button";
import { Copy, ExternalLink, Mail } from "lucide-react";
import { useToast } from "@/hooks/use-toast";
export function EmailSetupInstructions() {
  const {
    toast
  } = useToast();
  const supabaseProjectUrl = import.meta.env.VITE_SUPABASE_URL;
  const copyToClipboard = (text: string, label: string) => {
    navigator.clipboard.writeText(text);
    toast({
      title: "Copied!",
      description: `${label} copied to clipboard`
    });
  };
  return <div className="space-y-6">
      

      <Card>
        <CardHeader>
          <CardTitle>Configure Authentication Email Hooks (Optional)</CardTitle>
          <CardDescription>
            Enable custom email templates for authentication emails
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <Alert>
            <AlertDescription>
              The send-auth-email edge function is deployed and ready. To use custom templates for authentication emails (signup, password reset, magic links), configure auth hooks in your backend settings.
            </AlertDescription>
          </Alert>

          <div className="space-y-3">
            <p className="text-sm text-muted-foreground">
              This configuration is managed through your Lovable Cloud backend. If you need to set up auth email hooks, you can access the backend dashboard below.
            </p>

            <div className="bg-muted p-3 rounded-md space-y-2">
              <p className="text-sm font-medium">Edge Function URL (if needed):</p>
              <div className="font-mono text-sm flex items-center justify-between gap-2">
                <span className="break-all">
                  {supabaseProjectUrl}/functions/v1/send-auth-email
                </span>
                <Button size="sm" variant="ghost" onClick={() => copyToClipboard(`${supabaseProjectUrl}/functions/v1/send-auth-email`, "Hook URL")}>
                  <Copy className="h-4 w-4" />
                </Button>
              </div>
            </div>
          </div>

          <Button variant="outline" className="w-full" onClick={() => window.open('https://docs.lovable.dev/features/cloud', '_blank')}>
            <ExternalLink className="h-4 w-4 mr-2" />
            View Lovable Cloud Documentation
          </Button>
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle>Test Email Templates</CardTitle>
          <CardDescription>
            Send test emails to verify your configuration
          </CardDescription>
        </CardHeader>
        <CardContent>
          <p className="text-sm text-muted-foreground mb-4">
            Use the Preview feature in the Email Templates tab to send test emails and verify that:
          </p>
          <ul className="list-disc list-inside space-y-1 text-sm text-muted-foreground">
            <li>Logo displays correctly</li>
            <li>All placeholders are replaced</li>
            <li>Links work properly</li>
            <li>Emails render correctly across different email clients</li>
          </ul>
        </CardContent>
      </Card>
    </div>;
}